import requestAction from '../../utils/requestAction'

export const fetchUsePrepayment = (prepaymentId: string, clientId?: string, params?: string, handleResponse?: (response: any) => void) =>
  requestAction('USE_PREPAYMENT_DETAIL', params)(`prepayments/usedetail?prepaymentId=${prepaymentId}${clientId ? '&clientId='+clientId: ''}`, 'GET',
    undefined,
    undefined,
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response) })
